import { createAction, props } from '@ngrx/store';
import { ICreditAgreementData, ICreditAgreementModel } from '@partners/api';

export class CreditAgreementActions {
  static reset = createAction('[Credit Agreement] Reset State');
  static updateModel = createAction('[Credit Agreement] Update Model', props<{ model: ICreditAgreementModel }>());
  static load = createAction('[Credit Agreement] Load');
  static loadSuccess = createAction(
    '[Credit Agreement] Load Success',
    props<{ model: ICreditAgreementModel; data: ICreditAgreementData }>()
  );
  static loadFailure = createAction('[Credit Agreement] Load Failure', props<{ error: any }>());
  static submit = createAction('[Credit Agreement] Submit');
  static submitSuccess = createAction('[Credit Agreement] Submit Success', props<{ model: ICreditAgreementModel; data: ICreditAgreementData }>());
  static submitFailure = createAction('[Credit Agreement] Submit Failure', props<{ error: any }>());
}
